import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataEntity } from 'src/app/models/data-entities';
import { CustomListExternalSourceConfig, ExternalDataSource } from 'src/app/models/external-data-source';

@Component({
    selector: 'wm-custom-list-external-source-config',
    templateUrl: './custom-list-external-source-config.component.html',
    styleUrl: './custom-list-external-source-config.component.css',
    standalone: false
})
export class CustomListExternalSourceConfigComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() externalDataSource: ExternalDataSource;
  @Input() entity: DataEntity;

  @Output() externalSourceUpdated: EventEmitter<any> = new EventEmitter<any>();

  sourceConfig: CustomListExternalSourceConfig;
  customListExternalDataAttributeCtrl: AbstractControl;

  constructor(
    private _ref: ChangeDetectorRef,
    private _fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    if (this.entity.externalDataSource) {
      // it's possible the saved ExternalDataSource is no longer a valid option in the design.
      // Workflow validation will catch that, just keep it from erroring here.
      if (this.externalDataSource) {
        this.sourceConfig = this.externalDataSource.sourceConfig as CustomListExternalSourceConfig;

        // apply any existing selections from the entity.externalDataSource
        if ((this.entity.externalDataSource.sourceConfig as CustomListExternalSourceConfig).selectedOption != null) {
          (this.externalDataSource.sourceConfig as CustomListExternalSourceConfig).selectedOption =
            (this.externalDataSource.sourceConfig as CustomListExternalSourceConfig).options
              .find(o =>
                o.attributeId.toLocaleLowerCase() ===
                (this.entity.externalDataSource.sourceConfig as CustomListExternalSourceConfig)
                  .selectedOption.attributeId.toLocaleLowerCase()
              );
        }
      }
    }

    this.form.addControl(
      'customListExternalDataAttribute',
      this._fb.control('', Validators.required)
    );

    this.customListExternalDataAttributeCtrl = this.form.controls[
      'customListExternalDataAttribute'
    ];
  }

  ngAfterViewChecked() {
    this._ref.detectChanges();
  }

  ngOnDestroy() {
    if (this.form.contains('customListExternalDataAttribute')) {
      this.form.removeControl('customListExternalDataAttribute');
    }
  }

  handleChanges() {
    this.externalSourceUpdated.emit();
  }
}
